import { Injectable } from '@angular/core';
import { ConfigService } from './../../infrastructure/config.service';
import { NetworkService } from './../../infrastructure/network.service';

@Injectable({
  providedIn: 'root'
})
export class ShippableProductsReportService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }
  // //Get Dealer Account List
  // public getDealerAuditAccountList() {
  //  return this.networkService.getRequest(this.configService.getDealerAuditAccountListUrl());
  // }

  // //Get Grower Account List
  // public getGrowerAuditAccountList() {
  //  return this.networkService.getRequest(this.configService.getGrowerAuditAccountListUrl());
  // }

  // //Get Dealer Order Audit Log
  // public getDealerOrderAuditLog(productFilters) {
  //  return this.networkService.postRequest(this.configService.getDealerOrderAuditLogUrl(), productFilters);
  // }

  // Get Grower Order Audit Log
  public getShippableProductList(filters) {
    return this.networkService.postRequest(this.configService.getShippableProductsReportUrl(), filters);
  }
}
